module.exports = __webpack_public_path__ + "images/delay-statistics-0ea3169db8346bfd26bbd047aee5871f.svg";